// Centralized data-testid constants for Waylthlane Financials
export const TID = {
    // Header / Nav
    headerLogo: 'header-logo',
    navHome: 'nav-home-link',
    navAbout: 'nav-about-link',
    navFounders: 'nav-founders-link',
    navServices: 'nav-services-link',
    navProcess: 'nav-process-link',
    navContact: 'nav-contact-link',
    headerCta: 'header-book-consultation-btn',
    mobileMenuToggle: 'mobile-menu-toggle',

    // Hero
    heroBookConsultation: 'hero-book-consultation-btn',
    heroContactUs: 'hero-contact-us-btn',

    // Trust metrics
    metricsExperience: 'metric-experience',
    metricsClients: 'metric-clients',
    metricsAdvisors: 'metric-advisors',
    metricsTrust: 'metric-trust',

    // Founders
    founderDeepti: 'founder-card-deepti',
    founderBhartendu: 'founder-card-bhartendu',
    founderShib: 'founder-card-shib',

    // Services
    serviceCard: (id) => `service-card-${id}`,
    investmentCard: (id) => `investment-card-${id}`,

    // FAQ
    faqItem: (id) => `faq-item-${id}`,

    // Contact form
    contactName: 'contact-form-name',
    contactEmail: 'contact-form-email',
    contactPhone: 'contact-form-phone',
    contactService: 'contact-form-service',
    contactMessage: 'contact-form-message',
    contactSubmit: 'contact-form-submit',
    contactSuccess: 'contact-form-success',
    contactError: 'contact-form-error',

    // Floating
    whatsappFloat: 'whatsapp-float-btn',
    mobileStickyCta: 'mobile-sticky-cta',

    // Footer
    footerPrivacy: 'footer-privacy-link',
    footerTerms: 'footer-terms-link',
    footerEmail: 'footer-email-link',
    footerPhone1: 'footer-phone-1-link',
    footerPhone2: 'footer-phone-2-link',
};

export const HOME = { emergentLink: 'emergent-link' };
